import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-exposure-reduction-plan-items',
  templateUrl: './exposure-reduction-plan-items.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-reduction-plan-items.component.scss'],
})
export class ExposureReductionPlanItemsComponent implements OnInit {

  errorHtml: string = "";

  constructor(
  ) {
    this.errorHtml = ErrorConstants.errorHtml;
  }

  ngOnInit(): void {
  }

}
